<template>
    <kgr-form-scaffold
        :pending="pending || pendingRemove"
        :with-delete-button="true"
        :save-button-disabled="saveButtonDisabled"
        edit-mode
        @primaryBtnClicked="updateOffering"
        @backBtnClicked="redirectToOverview"
        @deleteBtnClicked="deleteOffering"
    >
        <template #additional-buttons>
            <button
                class="kgr-button kgr-button--accent"
                @click="redirectToAppointmentView"
            >
                {{ $t('offering.toAppointmentView') }}
            </button>
        </template>
        <kgr-offering-edit-form
            v-if="offering !== null"
            :club-id="clubId"
            :offering-prop="offering"
            :error="error"
            :save-action="pending"
            :sales-list-module-enabled="salesListModuleEnabled"
            @enter="updateOffering"
            @appointmentInvalid="saveButtonDisabled = $event"
        />
        <template #additional-footer-button>
            <kgr-archive-offering-button
                v-if="null !== offering"
                :offering="offering"
                @archiveOffering="offering.archived = true"
                @restoreOffering="offering.archived = false"
            />
        </template>
    </kgr-form-scaffold>
</template>

<script>
import ArchiveOfferingButton from '../../components/offering/ArchiveOfferingButton.vue';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrOfferingEditForm from '../../components/offering/OfferingTrainingEditForm';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository';
import OfferingValidator from '../../js/offering/OfferingValidator'
import TrainingOfferingRepository from '../../js/repository/club/offering/TrainingOfferingRepository';

export default {
    components: {
        'kgr-archive-offering-button': ArchiveOfferingButton,
        'kgr-form-scaffold': FormScaffold,
        'kgr-offering-edit-form': KgrOfferingEditForm,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        offeringId: {
            type: String,
            required: false,
        },
        salesListModuleEnabled: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            pendingRemove: false,
            offering: null,
            error: new Error(),
            saveButtonDisabled: false,
        };
    },
    computed: {
    },
    created() {
        if (this.offeringId.length !== 0) {
            this.loadOffering();
        }
    },
    methods: {
        loadOffering() {
            TrainingOfferingRepository.find(this.offeringId)
                .then(offering => this.offering = offering)
                .catch(() => this.$notify.error('error.loadingData'));
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        updateOffering() {
            this.error = OfferingValidator.validateTrainingOffering(this.offering);
            if (!this.error.isEmpty()) {
                return this.$notify.error('saveChanges.error');
            }

            this.pending = true;
            TrainingOfferingRepository.update(this.offering)
                .then(() => {
                    this.loadArchivable();
                    this.$notify.success('saveChanges.success');
                })
                .catch(error => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                })
                .finally(() => this.pending = false);
        },
        loadArchivable() {
            if (!this.offering.archived) {
                OfferingRepository.isArchivable(this.offeringId)
                    .then(response => this.offering.isArchivable = response);
            }
        },
        redirectToAppointmentView() {
            window.location = `/backend/clubs/${this.clubId}/training-offerings/${this.offering.id}/view`;
        },
        deleteOffering() {
            if (this.offering.isDeletable) {
                showConfirm(this.$t('confirm'), this.$t('Soll das Training wirklich gelöscht werden?', {}), () => {
                    this.pendingRemove = true;
                    OfferingRepository.delete(this.offering.id)
                        .then(() => {
                            this.$notify.success('Das Training wurde gelöscht');
                            this.redirectToOverview();
                        })
                        .catch(() => this.$notify.error('Das Training konnte nicht gelöscht werden'))
                        .finally(() => this.pendingRemove = false);
                }, 'Ok');
            } else {
                showAlert(this.$t('offering.training.notDeletable'), this.$t('offering.training.notDeletable.information', {}));
            }
        },
    },
    render() {
        return this.$scopedSlots['redirectToAppointmentView']()
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
